import { f7 } from 'framework7-react';
import { useCallback, useMemo } from 'react';
import { useRepairDamagedImageData } from './hook/useRepairDamagedImageData';
import { useStorageItem } from './hook/useStorageItem';
import { RepairDamagedImage } from './repairDamagedImage/repairDamagedImage';
import { PageTemplateComponent } from './util/common/pageTemplate/pageTemplate';
import { paths } from '@/config/paths';

export const RepairDamagedImagePage = () => {
  const { stored } = useStorageItem<{
    fromPage: string;
    inspectionID: number;
  }>({ key: 'repairCheckDamagedImage' });

  const inspectionID = useMemo(
    () => stored?.inspectionID ?? 0,
    [stored?.inspectionID],
  );

  const { damagedImageListData } = useRepairDamagedImageData({
    inspectionID,
  });

  const handleClickBack = useCallback(() => {
    const pathName = stored?.fromPage ?? paths.maintenance;
    f7.views.main.router.navigate(pathName);
  }, [stored?.fromPage]);

  return (
    <PageTemplateComponent
      pageName={'repairDamagedImage'}
      title={'損傷箇所の画像'}
      onBack={handleClickBack}
    >
      <RepairDamagedImage data={damagedImageListData} />
    </PageTemplateComponent>
  );
};
